import { withTranslation } from 'react-i18next';
import { Card, CardBody, CardHeader, Col, Row, UncontrolledTooltip } from 'reactstrap';
import StatusDropdown from './StatusDropdown';
import { translations } from '../../statuses';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { formatCurrency, formatDate } from '../../../../helpers/format';
import { Can } from '../../../../helpers/casl';
import { first } from 'lodash';

const CashbackInfo = (props) => {
  const { order, isLoading } = useSelector(
    createSelector(
      (store) => store.Order,
      (slice) => ({
        isLoading: slice.isLoading,
        order: slice.order,
      })
    )
  );
  const reserve = first(order?.reserve);
  const showConsumed = order.status === 'paid' || reserve?.status !== 'active';

  return (
    <>
      <Row>
        <Col sm={12} lg={4}>
          {isLoading ? (
            <div className="skeleton card" style={{ height: '117px' }} />
          ) : (
            <Card className="text-center">
              <CardHeader className="bg-black text-white text-uppercase">
                {props.t('order-status-detail')}
              </CardHeader>
              <CardBody>
                <div className="d-flex justify-content-center gap-2">
                  <h4 className="fw-bold h-auto text-success">
                    {translations[order?.cashback?.status]?.label}
                  </h4>

                  <Can I="update" a="sales_management">
                    <StatusDropdown icon="bx-edit-alt" order={order} />
                  </Can>
                </div>
              </CardBody>
            </Card>
          )}
        </Col>

        <Col sm={12} lg={4}>
          {isLoading ? (
            <div className="skeleton card" style={{ height: '117px' }} />
          ) : (
            <Card className="text-center">
              <CardHeader className="bg-dark text-white text-uppercase">
                {props.t('cashback-generated')}
              </CardHeader>
              <CardBody>
                <h4 className="fw-bold">
                  {formatCurrency((order?.cashback?.generated || order?.items?.reduce((total, item) => total + item.generatedCashback ?? 0, 0)) ?? 0)}
                </h4>
              </CardBody>
            </Card>
          )}
        </Col>

        <Col sm={12} lg={4}>
          {isLoading ? (
            <div className="skeleton card" style={{ height: '117px' }} />
          ) : (
            <Card className="text-center">
              <CardHeader className="bg-dark text-white text-uppercase">
                {showConsumed ? props.t('order-used-cashback2-detail') : props.t('order-reserved-balance2')}
              </CardHeader>
              <CardBody>
                <h4 className="fw-bold">
                  {showConsumed ? formatCurrency(order?.cashback?.used ?? 0) : formatCurrency(reserve?.value ?? 0)}
                  {!showConsumed && (
                    <>
                      <i
                        className="ri-information-line ms-2"
                        style={{ cursor: 'pointer', fontSize: '14px' }}
                        id="required-field-info"
                      ></i>
                      <UncontrolledTooltip
                        placement="top"
                        target="required-field-info"
                      >
                        {props.t('order-detail-reserve')}
                      </UncontrolledTooltip>
                    </>
                  )}
                </h4>
              </CardBody>
            </Card>
          )}
        </Col>
      </Row>

      <Row className="mb-4">
        <Col sm={12} lg={6}>
          {isLoading ? (
            <div className="skeleton card" style={{ height: '57px' }} />
          ) : (
            <Card>
              <CardBody>
                <div className="d-flex flex-column flex-sm-row justify-content-between">
                  <span className="fs-5 fw-semibold text-dark">
                    {props.t('ticket')}
                  </span>
                  <span className="fs-5 text-muted">{order?.ticket}</span>
                </div>
              </CardBody>
            </Card>
          )}
        </Col>

        <Col sm={12} lg={6}>
          {isLoading ? (
            <div className="skeleton card" style={{ height: '57px' }} />
          ) : (
            <Card>
              <CardBody>
                <div className="d-flex flex-column flex-sm-row justify-content-between">
                  <span className="fs-5 fw-semibold text-dark">
                    {props.t('date')}
                  </span>
                  <span className="fs-5 text-muted">
                    {formatDate(
                      order?.externalCreatedAt ?? order?.createdAt,
                      'DD/MM/Y'
                    )}
                  </span>
                </div>
              </CardBody>
            </Card>
          )}
        </Col>

        {/* Mock */}
        <Col sm={12} lg={6}>
          {isLoading ? (
            <div className="skeleton card" style={{ height: '57px' }} />
          ) : (
            <Card>
              <CardBody>
                <div className="d-flex flex-column flex-sm-row justify-content-between">
                  <span className="fs-5 fw-semibold text-dark">
                    {props.t('sales-channel')}
                  </span>
                  <span className="fs-5 text-muted">
                    {order?.salesChannel ?? '-'}
                  </span>
                </div>
              </CardBody>
            </Card>
          )}
        </Col>
        <Col sm={12} lg={6}>
          {isLoading ? (
            <div className="skeleton card" style={{ height: '57px' }} />
          ) : (
            <Card>
              <CardBody>
                <div className="d-flex flex-column flex-sm-row justify-content-between">
                  <span className="fs-5 fw-semibold text-dark">
                    {props.t('start-of-strategy')}
                  </span>
                  <span className="fs-5 text-muted">
                    {order?.strategyStartDate
                      ? formatDate(order?.strategyStartDate, 'DD/MM/Y')
                      : '-'}
                  </span>
                </div>
              </CardBody>
            </Card>
          )}
        </Col>
      </Row>
    </>
  );
};

export default withTranslation()(CashbackInfo);
